import React from "react";
import "./Footer.css";
import logo from '../../assets/logo/test-transparent.svg';

export default function Footer() {
  return (
    <footer id="contact" className="site-footer on-dark">
      <div className="container footer-content">
        <div className="footer-section footer-brand">
          <img src={logo} alt="Pinto Painting Inc." className="footer-logo" />
          <p className="footer-tagline">
            Interior &amp; exterior painting done with precision and care.
          </p>
        </div>

        <div className="footer-section footer-contact">
          <h3>Contact Us</h3>
          <a href="tel:+15416578153" className="footer-link-lg">
            (541) 657-8153
          </a>
          <a href="mailto:pintopainting@pm.me" className="footer-link-lg">
            pintopainting@pm.me
          </a>
          <p className="footer-note">Call or text for a free estimate</p>
        </div>

        <div className="footer-section">
          <h3>Our Location</h3>
          <p>34072 Santiam Hwy</p>
          <p>Lebanon, Oregon 97355</p>
          <p className="footer-license">CCB# 2446104</p>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>&copy; {new Date().getFullYear()} Pinto Painting Inc.</p>
        <p>All rights reserved.</p>
      </div>
    </footer>
  );
}
